import { createAction } from '@reduxjs/toolkit';
import { ReceiveErrorPayload } from '€lib/reducers/createDataSlice';
import { ReceiveDashboardInitPayload } from './dashboard-types';

export const actions = {
    requestData: createAction('dashboard/requestData'),
    receiveDataSuccess: createAction<ReceiveDashboardInitPayload>('dashboard/receiveDataSuccess'),
    receiveDataFailure: createAction<ReceiveErrorPayload>('dashboard/receiveDataFailure'),
};

export const { requestData, receiveDataSuccess, receiveDataFailure } = actions;
export default actions;
